const signatureChainType = {
  ORDERED: 'ORDERED',
  UNORDERED: 'UNORDERED'
}

export default signatureChainType
